<template>
  <div class="report" :style="{
            width: scale + '%',
          }">
    <img v-for="(v, i) in images" :key="i" :src="`/preview/${v}`">
    <div class="tool" v-show="showTool">
      <button @click="scaleD">放大</button>
      <span class="tip" @click="resize">{{scale}}%</span>
      <button @click="scaleX">缩小</button>
      <button @click="download">下载报告</button>
    </div>
  </div>
</template>
<script>
import { getReport } from '@/api'
export default {
  name: 'reportlist',
  components: {
  },
  data() {
    return {
      id: 0,
      scale: 100,
      report: undefined,
      images: [],
      showTool: true
    }
  },
  computed: {
    location() {
      return document.location.protocol + "//" + document.domain + "/preview/" + this.report.reportUrl
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    if (this.id) {
      getReport(this.id).then(res => {
        this.report = res
        this.images = res.images.split('|')
      })
    }
    if (this.$route.query.pc) {
      this.showTool = false
    }
  },
  create() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
  },
  methods: {
    download() {
      window.location.href = document.location.protocol + "//" + document.domain + "/preview/" + this.report.reportUrl
    },
    loadPdf(e, i) {
    },
    onCopyLink() {
      let _this = this;
      let clipboard = new this.clipboard(".copy-btn");
      clipboard.on('success', function () {
        _this.$toast("复制成功")
      });
      clipboard.on('error', function () {
        _this.$toast("复制失败")
      });
    },
    scaleD() {
      this.scale += 5
    },
    resize() {
      this.scale = 100
    },
    scaleX() {
      if (this.scale === 100) {
        return
      }
      this.scale += -5
    }
  }
}
</script>

<style lang="scss">
.report {
  width: 100%;
  img {
    width: 100%;
  }
}
.tool {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  button{
    border: none;
    color: #21AEC3;
  }
  .tip {
    color: #21AEC3;
  }
}
</style>
